"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StethoscopeSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M2 4a2 2 0 0 1 2-2h2.4a2 2 0 1 1 0 4h-.29c.162 1.634.511 3.596 1.096 5.32.43 1.264.94 2.26 1.485 2.905.522.618.947.775 1.309.775s.787-.157 1.31-.775c.545-.645 1.055-1.641 1.484-2.905.585-1.724.934-3.686 1.096-5.32h-.29a2 2 0 1 1 0-4H16a2 2 0 0 1 2 2c0 2.129-.399 5.6-1.419 8.605-.508 1.499-1.217 3.02-2.218 4.204-.624.737-1.405 1.388-2.346 1.785.032 1.184.13 2.443.415 3.516.208.779.471 1.274.725 1.55.194.21.416.34.843.34.014 0 .017-.001.019-.002.005-.002.034-.013.089-.055.123-.095.315-.3.557-.698.501-.828.934-1.996 1.455-3.428l.04-.107c.47-1.296 1.026-2.826 1.755-4.028C18.647 14.474 19.92 13 22 13c1.458 0 2.703.473 3.664 1.354.916.84 1.437 1.923 1.748 2.933.543 1.765.585 3.813.588 5.248a4 4 0 1 1-4 0c-.007-1.431-.055-2.913-.412-4.072-.189-.615-.418-.97-.627-1.16-.164-.15-.42-.303-.961-.303-.014 0-.017.001-.019.002-.005.002-.034.013-.089.055-.123.095-.315.3-.557.698-.501.828-.934 1.996-1.455 3.428l-.04.107c-.47 1.296-1.026 2.826-1.755 4.028C17.353 26.526 16.081 28 14 28c-1.573 0-2.851-.62-3.782-1.628-.871-.943-1.358-2.136-1.65-3.232-.4-1.501-.519-3.168-.554-4.533-.955-.396-1.747-1.053-2.377-1.798-1-1.183-1.71-2.705-2.218-4.204C2.399 9.601 2 6.13 2 4z" stroke="none"></path>';
var StethoscopeSVG = function StethoscopeSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.StethoscopeSVG = StethoscopeSVG;
StethoscopeSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(StethoscopeSVG);
exports.default = _default;